import { Component, OnInit, ElementRef, TemplateRef } from '@angular/core';
import { ACCESSIBLE_CHANNEL_TYPE, ENDPOINTS } from '../app.config';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { CompanyService } from '../company.service';
import { UserInfoService } from '../shared/user-info.service';

@Component({
  selector: 'app-bus',
  templateUrl: './bus.component.html',
  styleUrls: ['./bus.component.css'],
  providers: [UserInfoService]
})
export class BusComponent implements OnInit {

  toaster: ToasterService;
  //favorite : boolean = true;
  newBus: createBusStation = {
    name: '',
    id: null,
    expected_eink_devices_count: null,
    is_favourite: true,
    bus_lines: null,
  };

  busIndex: number;
  buslist: BustStation[] = [];
  deletebuslist: BustStation[] = [];
  selectedbusId: number;
  filter: string;
  idfilter: string;
  getBuslistConfig: any;
  //pagination variables
  currentPage: number;
  totalPages: number;
  buslistTotal: number;
  buslistPerPage: number;
  gettingBustListInProgress: boolean;
  syncinprogress: boolean;
  counter: number = 0;
  @BlockUI() blockUI: NgBlockUI;
  router: Router;

  companyName: string;
  userRole: string;
  businesOwnerName: string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');

  companyId: string;
  channelsList = [];
  route: ActivatedRoute;
  sub: any;
  companyService: CompanyService;


  constructor(toaster: ToasterService, private elem: ElementRef, router: Router, private userInfoService: UserInfoService,
    companyservice : CompanyService, route: ActivatedRoute) {
    this.toaster = toaster;
    this.router = router;
    this.companyService = companyservice;
    this.route = route;
  }



  ngOnInit() {
    this.getUserInfo();

    //this.getCurrentCompanyEinkInfo();

    this.getBuslistConfig = {
      perPage: 10,
      filtering: false,
      filteringBy: [],
      q: '',
      ids: ''
    };

    this.currentPage = 1;
    this.buslistPerPage = 10;
    this.gettingBustListInProgress = false;
    this.syncinprogress = false;
    this.filter = '';
    this.idfilter = '';
    this.getAllBustStations('busname');
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
    });
  }


  async getCurrentCompanyEinkInfo() {


    let url = this.router.url.toString().split('/');
    let companyId = '';
    if (url.length > 2) {
      companyId = url[2];
      await axios.get(ENDPOINTS.DELETE_COMPANY.replace(':id', companyId))
        .then(response => {
          if (!response.data.eink_support) {
            if(this.userRole!="ADMINISTRATOR")
            this.router.navigate(['/']);
          }


        },error=>{
          console.log(error);
        });
    }
  }

  NumberValidation(busItem, field) {

    if (field == 'id') {
      if (busItem.id < 0) {
        this.buslist[this.busIndex].id = 0;
        return false;
      }
    }
    else if (field == 'expected_devices') {
      if (busItem.expected_eink_devices_count < 0) {
        this.buslist[this.busIndex].expected_eink_devices_count = 0;
        return false;
      }
    }
    return true;
  }

  getAllBustStations(field) {


    if(field=="busid")
    {
      axios
      .get(ENDPOINTS.GET_BUS_ALL + '?page=' + this.currentPage + '&per_page=' + this.buslistPerPage + '&ids=' + this.getBuslistConfig.ids)
      .then(response => {
        this.initPagingVars(response);
        this.buslist = response.data
      });
    }
    else if(field=="busname"&&this.getBuslistConfig.q!="")
    {
      axios
      .get(ENDPOINTS.GET_BUS_ALL + '?page=' + this.currentPage + '&per_page=' + this.buslistPerPage + '&q=' + this.getBuslistConfig.q)
      .then(response => {
        this.initPagingVars(response);
        this.buslist = response.data
      });
    }
    else
    {
      axios
      .get(ENDPOINTS.GET_BUS_ALL + '?page=' + this.currentPage + '&per_page=' + this.buslistPerPage )
      .then(response => {
        this.initPagingVars(response);
        this.buslist = response.data
      });
    }

  }

  async getAllBustStationsSync() {
    // let config = {
    //   onUploadProgress: progressEvent => {
    //     let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    //     // do whatever you like with the percentage complete
    //     // maybe dispatch an action that will update a progress bar or something
    //     console.log(percentCompleted);
    //   }
    // }

    this.syncinprogress = true;
    this.blockUI.start('Please wait while bus stations are being fetched.' + '\n\n' + ' It might take a few minutes to complete.');
    //updating ui design of wait spinner
    let elem = document.querySelector('.message');
    elem.setAttribute('style', 'width:400px;margin:0 auto;');
    axios
      .get(ENDPOINTS.GET_BUS_SYNC_ALL)
      .then(response => {
        this.getAllBustStations('plain');
        this.syncinprogress = false;
        this.blockUI.stop();
        this.toaster.pop("success", "Fetched successfully");
      });


  }

  CreateBus() {
    const data = {
      id: this.newBus.id,
      name: this.newBus.name,
      expected_eink_devices_count: this.newBus.expected_eink_devices_count,
      is_favourite: this.newBus.is_favourite,
      bus_lines: this.newBus.bus_lines
    };
    axios
      .post(ENDPOINTS.POST_BUS, data)
      .then(response => {

        this.getAllBustStations('plain');
        this.toaster.pop('success', 'Bus added Successfully');
      },
        error => {
          this.toaster.pop('error', 'Error in adding bus');

        });


  }

  updateBus(updatebusObj, field) {


    if (!this.NumberValidation(updatebusObj, field)) return;

    if (field == 'name') {
      axios.patch(ENDPOINTS.UPDATE_BUS.replace(':busId', updatebusObj.id), { name: updatebusObj.name })
        .then(response => {

        });
    }
    else if (field == 'favorite') {

      updatebusObj.is_favourite = !updatebusObj.is_favourite;
      axios.patch(ENDPOINTS.UPDATE_BUS.replace(':busId', updatebusObj.id), { is_favourite: updatebusObj.is_favourite })
        .then(response => {

          //this.buslist.find(p=>p.id = updatebusObj.id).is_favourite = updatebusObj.is_favourite;
        });
    }
    else if (field == 'id') {

      axios.patch(ENDPOINTS.UPDATE_BUS.replace(':busId', this.selectedbusId.toString()), { id: updatebusObj.id })
        .then(response => {
          console.log(response);
        },
          error => {
            console.log(error);
          });
    }
    else if (field == 'expected_devices') {
      axios.patch(ENDPOINTS.UPDATE_BUS.replace(':busId', updatebusObj.id), { expected_eink_devices_count: updatebusObj.expected_eink_devices_count })
        .then(response => {
          console.log(response);
        },
          error => {
            console.log(error);
          });
    }
  }

  BusKeyDown(e: KeyboardEvent, value) {
    //
    if (this.counter == 0) {
      this.busIndex = this.buslist.indexOf(this.buslist.find(p => p.id == value));
      this.selectedbusId = value;
      this.counter++;
    }


    if (e.keyCode == 13 && !e.shiftKey) {
      // prevent default behavior
      e.preventDefault();
    }
  }

  UpdateDeleteList(busobj) {
    if (busobj.is_selected) {
      this.deletebuslist.push(busobj);
    }
    else {
      let index = this.deletebuslist.indexOf(busobj);
      this.deletebuslist.splice(index, 1);
    }

  }

  DeleteBustStation() {
    this.deletebuslist.forEach(element => {
      let item = element;
      axios.delete(ENDPOINTS.DELETE_BUS.replace(':busId', item.id.toString()))
        .then(response => {
          this.getAllBustStations('plain');
          this.toaster.pop('success', 'Bus deleted Successfully');
        }
        );
    });

  }

  NavigateToEinkDevices(busid)
  {

    localStorage.setItem("busId",busid.toString());
    let companyId = this.getCompanyIdFromUrl();
    this.router.navigate([
      '/einkdevices/' + companyId
    ]);
  }

  getCompanyIdFromUrl()//in case of administrator login
  {
    let url = this.router.url.toString().split('/');
    let companyId = '';
    if(url.length>2)
    {
      companyId = url[2];
    }
    return companyId;
  }
  //search

  searchBuslist(field) {
    this.currentPage = 1;
    this.getAllBustStations(field);
  }
  //Pagination

  loadbuslist(page, isDisabled) {
    if (!isDisabled && !this.gettingBustListInProgress) {
      this.currentPage = page;
      this.getAllBustStations('plain');
    }
  }
  generatePages(current) {

    if (!this.totalPages) {
      return [];
    }
    if (!current) current = 1;
    const arr = [];
    let lenght = current + 5;

    if (lenght > this.totalPages) {
      lenght = this.totalPages;
    }
    for (let i = current; i < lenght; i++) {
      arr.push(i);
    }

    return arr;
  }

  changeId() {
    if (this.newBus.id < 0) this.newBus.id = 0;
  }
  changeEinkDevice() {
    if (this.newBus.expected_eink_devices_count < 0) this.newBus.expected_eink_devices_count = 0;
  }


  initPagingVars(response) {

    this.buslistTotal = parseInt(response.headers['total'], 10);
    this.buslistPerPage = parseInt(response.headers['per-page'], 10);
    this.totalPages = Math.floor(
      this.buslistTotal % this.buslistPerPage,
    ) === 0
      ? this.buslistTotal / this.buslistPerPage
      : Math.floor(this.buslistTotal / this.buslistPerPage) + 1;
  }


  getUserInfo() {

    this.userInfoService.getInformations()
      .subscribe((info: UserInfo) => {
        this.userRole = info.userRole;
        this.companyName = info.companyName;
        this.businesOwnerName = info.businesOwnerName;
        this.getCurrentCompanyEinkInfo();
        this.getCompanyInfo();
      });
  }


  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {

        _self.companyName = response.data.name;
        _self.channelsList = _self.generateChannelsList(response.data.channels);
      });
  }
  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name,
      });
    }
    return channelsList;
  }

}

export interface UserInfo {
  userRole: string,
  companyName: string,
  businesOwnerName?: string
}

interface BustStation {
  bus_lines: any,
  created_at: "",
  eink_devices: any,
  eink_devices_count: number,
  expected_eink_devices_count: number,
  id: number,
  is_favourite: boolean,
  name: string,
  updated_at: any,
  is_selected: boolean
}

interface createBusStation {
  name: string,
  id: number,
  expected_eink_devices_count: number,
  is_favourite: boolean,
  bus_lines: any,
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/bus/bus.component.ts